import * as xmldoc from 'xmldoc';

export class MissingResponseValueError extends Error {
  constructor(requestName: string, xPath: string, response: xmldoc.XmlElement) {
    /* istanbul ignore next line */
    super(
      `Error in Prolexis API response for request: ${requestName}, missing value for path: ${xPath}.\n
      Full response:\n
      ${response.toString()}
      `,
    );
  }
}

export class RestartingCorrectionSessionError extends Error {
  constructor() {
    /* istanbul ignore next line */
    super(
      "You're trying to restart a correction session (probably by calling start method more than once)",
    );
  }
}

export class CorrectionSessionNotStarted extends Error {
  constructor() {
    /* istanbul ignore next line */
    super(
      "You're trying to apply a correction on a not started session (start method has not been called)",
    );
  }
}

export class CantApplyCorrectionError extends Error {
  constructor() {
    /* istanbul ignore next line */
    super('Global error: cant apply correction');
  }
}

export class OutOfBoundError extends Error {
  constructor() {
    /* istanbul ignore next line */
    super('There is no more error to correct/ignore');
  }
}

export class MultipleCorrectionInfiniteLoop extends Error {
  constructor() {
    /* istanbul ignore next line */
    super('Error during multiple correction application, infinite loop avoided');
  }
}

export class EmptyText extends Error {
  constructor() {
    /* istanbul ignore next line */
    super('Error cannot start correction session on empty text');
  }
}

export class DesynchronizationProlexis extends Error {
  constructor() {
    /* istanbul ignore next line */
    super('Error the md5 check of the text differs from the prolexis response');
  }
}
